import React from 'react';
import { Card, Tab, Tabs } from 'react-bootstrap';

import {
  CreateUpdateEstimateItemDto,
  GetProfileDto,
  GetProjectDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { ParametersTab } from './ParametersTab';
import { SalesTab } from './SalesTab';
import { PurchaseInvoicesTab } from './PurchaseInvoicesTab';
import { SalesInvoicesTab } from './SalesInvoicesTab';
import { NoOrderRequiredTab } from './NoOrderRequiredTab';

interface EstimateItemTabsPanelProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  estimateItem: CreateUpdateEstimateItemDto;
  project?: GetProjectDto;
  profile?: GetProfileDto;
  propertyChange: (obj: Partial<CreateUpdateEstimateItemDto>) => void;
  isSalesBlocked: boolean;
  isPurchaseBlocked: boolean;
  id?: string;
  positionName?: string;
  onNoOrderRequiredChange: (noOrderRequired: boolean) => void;
}

export const EstimateItemTabsPanel: React.FC<
  EstimateItemTabsPanelProps
> = props => {
  const pok = usePokCore();
  const { t, tk } = useTranslation('projectLng');
  const { estimateItem, project, profile, propertyChange } = props;

  return (
    <Card className="my-3">
      <Tabs
        className="mb-3"
        activeKey={props.activeTab}
        onSelect={tab => props.setActiveTab(tab as string)}
      >
        <Tab eventKey="amounts" title={t(tk.estimates.amounts)} className="m-3">
          <SalesTab
            estimateItem={estimateItem}
            project={project}
            profile={profile}
            propertyChange={propertyChange}
            isSalesBlocked={props.isSalesBlocked}
            isPurchaseBlocked={props.isPurchaseBlocked}
            lang={pok.getLanguage()}
          />
        </Tab>
        <Tab
          eventKey="parameters"
          title={t(tk.estimates.parameters)}
          className="m-3"
        >
          <ParametersTab
            estimateItem={estimateItem}
            project={project}
            profile={profile}
            propertyChange={propertyChange}
          />
        </Tab>
        <Tab
          eventKey="purchaseInvoices"
          title={t(tk.estimates.fvz)}
          className="m-5"
        >
          <PurchaseInvoicesTab
            estimateItemId={props.id}
            downloadDocuments={
              project?.purchaser?.budget?.downloadDocuments || false
            }
            name={`${project?.name}_${props.positionName || ''}`}
            number={project?.number || ''}
          />
        </Tab>
        <Tab
          eventKey="salesInvoices"
          title={t(tk.estimates.fvs)}
          className="m-5"
        >
          <SalesInvoicesTab estimateItemId={props.id} />
        </Tab>
        {process.env.REACT_APP_TIMELINE?.toLocaleLowerCase() === 'on' && (
          <Tab
            eventKey="contracts"
            title={t(tk.estimates.contracts)}
            className="m-3"
          >
            <NoOrderRequiredTab
              estimateItemId={props.id}
              onNoOrderRequiredChange={props.onNoOrderRequiredChange}
            />
          </Tab>
        )}
      </Tabs>
    </Card>
  );
};
